<template>
  <div class="app-container">
 
    <el-form ref="queryForm" :model="queryParams" :inline="true" label-width="68px">
      <el-row>
            <el-form-item label="歌曲名称">
              <el-input v-model="queryParams.qumu_name" placeholder="请输入歌曲名称" @keyup.enter.native="handleQuery2" clearable  size="small" />
            </el-form-item>
            <el-form-item>
        <el-button type="primary" icon="el-icon-search" :loading="loading" size="mini"
          @click="handleQuery2">查询</el-button>
        <!-- <el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button> -->
      </el-form-item>
        </el-row>
    
    </el-form>

    <div class="gap"></div>

    <div v-for="(item,index) in list">
     
      <div class="list-item"  :index="index" @click="toDetail(item)">
        {{ item.qumu_name }} - {{ item.qumu_mark }} 
        <img class="icon" src="../assets/music.png" alt="">
        <!-- <img class="icon" src="../assets/xi.png" alt=""> -->
      </div>
      
    </div>
    <el-pagination v-show="total > 0" :pageSize="pageSize" :total="total" @current-change="getList" @prev-click='getList'
      @next-click="getList" />

  </div>



</template>

<script>
import config from '../../config/config'
import { recordList, qukuAdd, qukuListAll, qukuDelete, qukuUpdate } from '../api/quku/index';
import { Notification, MessageBox, Message, Link } from "element-ui";
export default {
  name: 'Operlog',
  data () {
    return {
      baseUrl:'',
      flag:false,
      fileList: [],
      limit: 2,
      baseURL: '',  //  图片上传地址
      dialogImageUrl: '',
      dialogVisible: false,
      disabled: false,
      intro: [
        { prod_type: 'C', label: 'C调' },
        { prod_type: 'D', label: 'D调' },
        { prod_type: 'E', label: 'E调' },
        { prod_type: 'F', label: 'F调' },
        { prod_type: 'G', label: 'G调' },
        { prod_type: 'A', label: 'A调' },
        { prod_type: 'bB', label: 'bB调' },
        { prod_type: 'B', label: 'B调' },
        { prod_type: 'bD', label: 'bD调' },
        { prod_type: 'bE', label: 'bE调' },
        { prod_type: 'bG', label: 'bG调' },
        { prod_type: 'bA', label: 'bA调' },
      ],
      show365: [
        { prod_type: '', label: '空' },
        { prod_type: '1', label: '是' },
        { prod_type: '0', label: '否' },
      ],
      stateOptions: [
      { prod_type: '', label: '空' },
        { prod_type: '1', label: '正常' },
        { prod_type: '0', label: '停用' },
      ],
      options: [
        { prod_type: '', label: '空' },
        { prod_type: '0', label: '专业考级' },
        { prod_type: '1', label: '经典老歌' },
        { prod_type: '2', label: '网络流行' },
        { prod_type: '3', label: '草原情怀' },
        { prod_type: '4', label: '古风雅韵' },
        { prod_type: '5', label: '红歌精选' },
        { prod_type: '6', label: '影视金曲' },
        { prod_type: '7', label: '西北风情' },
        { prod_type: '8', label: '国外歌曲' },
        { prod_type: '9', label: '其他类型' },
      ],

      list: [],
      form: {
        qumu_name: '',
        qumu_qufeng: '',
        qumu_pic: '',
        qumu_365_show: '1',
        qumu_state: '1',
        qumu_mark: '',
        qumu_banzou: '',
        qumu_shuoming: '',
        qumu_zhifa: '',
      },
      open: false,
      pageIndex: 1,
      pageSize: 20,
      // 禁用状态
      disabled: false,
      queryParams: {
        qumu_365_show:'',
        qumu_name:''
      },
      loading: false,
      // table 列表数据
      list: [],
      // 总条数
      total: 0,

    }
  },

 



  created () {
    debugger
    debugger
    this.baseUrl = config.baseUrl;
  

    let flag = sessionStorage.getItem('flag')
    if(!flag){
    return  this.$router.push('/')
    }
    let userInfo   = sessionStorage.getItem('userInfo') || {};
    userInfo = JSON.parse(userInfo)
    let  queryParams = this.queryParams;
    queryParams.qumu_365_show = '1';
    this.queryParams = queryParams
    this.handleQuery2()
  },
  methods: {
    stest(){
      alert(1)
    },
    toDetail(e){
    console.log(e)
    let detail = JSON.stringify(e)
    localStorage.setItem('detail',detail)
      this.$router.push('/QupuDetail')
  },
  	//	获取曲库列表
	getqukuListAll(){
    let params = this.queryParams;
      params.pageIndex = this.pageIndex;
      params.pageSize = this.pageSize;
      this.list = []
		qukuListAll(params).then(res => {
			let list = this.data.list.concat(res.list)
			console.log(res)
			this.setData({
				list:list,
				total:res.total
			})
		})
	},




    handleAvatarSuccess (res, file) {
      console.log(this.fileList)
      this.fileList.push(file)
      console.log(this.fileList)
    },
    handleRemove (file, fileList) {
      console.log(file, fileList);
      this.fileList = fileList
      console.log(this.fileList)
    },
    handlePictureCardPreview (file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handleDownload (file) {
      console.log(file);
    },
    handleUpdate (row) {
      this.flag = false,
      this.open = true;
      let fileList = row.qumu_pic.split(',');
      let temp = [];
      for(let i=0;i<fileList.length;i++){
        debugger
        let obj = {name: 'food.jpg', url:this.baseUrl +  fileList[i]}
        temp.push(obj)
      }
      debugger
      this.fileList = temp
      
      this.form = {
        id: row.id,
        qumu_name: row.qumu_name,
        qumu_qufeng: row.qumu_qufeng,
        // qumu_pic: row.qumu_pic,
        qumu_365_show: row.qumu_365_show,
        qumu_state:row.qumu_state,
        qumu_mark: row.qumu_mark,
        qumu_banzou: row.qumu_banzou,
        qumu_shuoming: row.qumu_shuoming,
        qumu_zhifa:row.qumu_zhifa,
        qumu_zimu:row.qumu_zimu,
        qumu_intro:row.qumu_intro,
      }
    },
    handleDelete (row) {
      let params = {
        id: row.id,
      }
      
      this.$confirm('确认删除吗？')
        .then(() => {
          qukuDelete(params).then(res => {
            this.$message.success('删除成功')
            this.handleQuery()
          })
        })
        .catch(_ => { });

    },
    submit () {
      console.log(this.form)
      debugger
      let fileList = this.fileList;
      let qumu_pic = []
      let baseUrl = this.baseUrl;
      for(let i=0;i<fileList.length;i++){
        console.log(fileList[i].url)
        if(fileList[i].url.indexOf(baseUrl) > -1){
          let url = fileList[i].url.replaceAll(baseUrl,'')
          qumu_pic.push(url)
        }else{
          qumu_pic.push(fileList[i].response.data.url)
        }

      }
      let params = this.form;
      params.qumu_pic = qumu_pic.toString()
      console.log(params)
      params.qumu_banzou = params.qumu_banzou.replaceAll('，',',')
      params.qumu_shuoming = params.qumu_shuoming.replaceAll('，',',')
      params.qumu_zhifa = params.qumu_zhifa.replaceAll('，',',')
      if(!params.qumu_name){
        return this.$message.error('曲目不能为空')
      }
     
      if(!params.id){
        if(!params.qumu_pic){
        return this.$message.error('请上传歌曲图片')
      }
      }
    
      if(!params.qumu_banzou){
        return this.$message.error('歌曲伴奏链接不能为空')
      }
      if(!params.qumu_shuoming){
        return this.$message.error('歌曲说明链接不能为空')
      }
      if(!params.qumu_zhifa){
        return this.$message.error('歌曲指法不能为空')
      }
      if(!params.qumu_mark){
        return this.$message.error('歌曲备注不能为空')
      }
      if (!params.id) {
        qukuAdd(this.form).then(res => {
          this.$message.success('新增成功')
          this.open = false
          this.handleQuery()
        })
      } else {
        qukuUpdate(this.form).then(res => {
          this.$message.success('修改成功')
          console.log(res)
          this.open = false
          this.handleQuery()
        })
      }
    },
    // 翻译评价类型
    transType (row) {
      let list = this.options;
      for(let i=0;i<list.length;i++){
        if(list[i].prod_type == row.qumu_qufeng){
          return list[i].label
        }
      }
    },
    // 365歌曲
    trans365 (row) {
      
      let list = this.show365
      for(let i=0;i<list.length;i++){
        if(list[i].prod_type == row.qumu_365_show){
          return list[i].label
        }
      }
    },
    // 状态翻译
    transState (row) {
      let list = this.stateOptions
      for(let i=0;i<list.length;i++){
        if(list[i].prod_type == row.qumu_state){
          return list[i].label
        }
      }
    },
     // 曲调
     transIntro (row) {
      let list = this.intro
      for(let i=0;i<list.length;i++){
        if(list[i].prod_type == row.qumu_shuoming){
          return list[i].label
        }
      }
    },

    //  退出
    logout () {
      localStorage.clear();
      this.$router.push('/')
    },
    // 新增按钮
    handleAdd () {
      this.open = true
      this.flag = true
      this.fileList = []
      this.form = {
        qumu_name: '',
        qumu_qufeng: '',
        qumu_pic: '',
        qumu_365_show: '',
        qumu_state: '1',
        qumu_mark: '',
        qumu_banzou: '',
        qumu_shuoming: '',
        qumu_zhifa: '',
        qumu_zimu: '',
      }
    },
    handleQuery2(){
      debugger
      this.pageIndex = 1;
      this.pageSize = 20;
      this.handleQuery()
    },
    // 查询按钮个
    handleQuery () {
      let params = this.queryParams;
      params.pageIndex = this.pageIndex;
      params.pageSize = this.pageSize;
      this.list = []
      qukuListAll(params).then(res => {
        
        this.list = res.data.list;
        console.log(this.list)
        this.total = res.data.total
        console.log(this.total)
      })
    },

    //  上一页面
    preClick (e) {

      this.pageIndex = e;
      if (pageIndex <= 1) { return }
      this.handleQuery()
    },
    // 下一页
    preClick () {
      let pageIndex = this.pageIndex + 1;

      if (pageIndex * this.pageSize >= this.total) {
        return
      }
      this.pageIndex = pageIndex;
      this.handleQuery()
    },
    // 获取列表
    getList (e) {
      this.pageIndex = e
      let params = this.queryParams;
      params.pageIndex = this.pageIndex;
      params.pageSize = this.pageSize;
      qukuListAll(params).then(res => {
        this.list = res.data.list;
        this.total = res.data.total
        console.log(this.total)
      })
    }
  }
}
</script>
<style scoped>
.app-container {
  margin-top: 40px;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.gap {
  margin: 30px 10px;
}

.title {
  color: black;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
.img{
  width: 50px;
  height: 50px;
  margin-left: 10px;
}
.el-upload-list--picture-card .el-upload-list__item{
  width: 100px;
  height: 100px !important;
}
.el-upload--picture-card{
  width: 100px;
  height: 100px !important;
  line-height: 100;
}

.list-item{
  display: flex;
  border-bottom: 1px solid gray;
  padding: 20px;
}
.icon{
  width: 20px;
  margin-left: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/qupu.vue